export default {
  categorySubject: {},
  categorySubjects: [],
}
